import {DefaultTheme} from 'styled-components';

import {isNil} from 'ramda';

import {getSafely, Nullish} from 'shared/web';

import {ThemeShadowsPath} from './foundationTheme';

export function getShadowByPath(
  shadow: ThemeShadowsPath | Nullish,
  theme: DefaultTheme
): string | undefined {
  if (isNil(shadow)) {
    return undefined;
  }

  return getSafely(theme.shadows, shadow);
}
